module.exports = __webpack_public_path__ + "../resources/images/emptyJunkFolder-a51e7ad7712bb9228150282274085267.svg";